import Vue from"vue";Vue.directive("open-mobile-navigation",{bind(e){e.onclick=()=>ceresStore.commit("setIsMobileNavigationOpen",!0)}});